module.exports = __webpack_public_path__ + "static/media/cowboys-silhouette.9a941327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/cowboys-silhouette.svg
// module id = 1327
// module chunks = 0